export function initLandingShare() {
  document.querySelectorAll('[data-landing-share]').forEach((root) => {
    const btn = root.querySelector('.landing-share__btn');
    const overlay = root.querySelector('.landing-share-overlay');
    const dialog = root.querySelector('.landing-share-dialog');
    if (!btn || !overlay || !dialog) return;

    // Escape transformed/opacity ancestors so the overlay covers the full viewport.
    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }

    let lastFocused = null;
    let isClosing = false;

    const closeTriggers = overlay.querySelectorAll('[data-landing-share-close]');

    function getFocusable() {
      return Array.from(
        overlay.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => el.offsetParent !== null);
    }

    function waitForDialogTransition(callback) {
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        dialog.removeEventListener('transitionend', onEnd);
        callback();
      };
      const onEnd = (event) => {
        if (event.target !== dialog) return;
        if (event.propertyName !== 'opacity' && event.propertyName !== 'transform') return;
        finish();
      };

      dialog.addEventListener('transitionend', onEnd);
      window.setTimeout(finish, 400);
    }

    function open() {
      if (isClosing) return;

      lastFocused = document.activeElement;
      overlay.hidden = false;
      overlay.classList.remove('is-open');
      void overlay.offsetHeight;
      overlay.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('landing-share-open');

      window.requestAnimationFrame(() => {
        const focusTarget = overlay.querySelector('.landing-share-close') || dialog;
        focusTarget?.focus();
      });
    }

    function close() {
      if (overlay.hidden || isClosing) return;

      isClosing = true;
      overlay.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');

      waitForDialogTransition(() => {
        overlay.hidden = true;
        isClosing = false;

        if (!document.querySelector('.landing-share-overlay:not([hidden])')) {
          document.body.classList.remove('landing-share-open');
        }

        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      });
    }

    btn.addEventListener('click', (event) => {
      event.preventDefault();
      if (overlay.hidden) {
        open();
      } else {
        close();
      }
    });

    closeTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        close();
      });
    });

    overlay.querySelectorAll('[data-landing-share-print]').forEach((printBtn) => {
      printBtn.addEventListener('click', (event) => {
        event.preventDefault();
        overlay.classList.remove('is-open');
        overlay.hidden = true;
        isClosing = false;
        btn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('landing-share-open');
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
        window.print();
      });
    });

    overlay.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }

      if (event.key !== 'Tab' || overlay.hidden) return;

      const focusable = getFocusable();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  });
}
